import Button from '@mostrans/web-components/components/base/Button'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
import React, { useCallback, useState } from 'react'
import FormGroup from '@mostrans/web-components/components/base/FormGroup';
import Select from '@mostrans/web-components/components/base/Select';
import { useGetAllOpportunityAdmin } from '../../../../shared/hooks/useGetMasterData';
import { UpdateOpportunityCandidate } from '../../../../GQL/mutations';
import { useApolloClient } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { toastError, toastSuccess } from '../../../../shared/helpers';
import { useGetListCandidateByOpportunityID } from '../../../../shared/hooks/useGetListCandidateByOpportunityID';
import { getCandidatesByOpportunityID } from '../../../../GQL/queries';
import { useSetRecoilState } from 'recoil';
import { globalLoadingAtom } from '../../../../shared/globalStates';

function ModalSwicthPosition(props) {
    const [modalOpen, setModalOpen] = useState(false)
    const [newOpportunityID, setNewOpporunityID] = useState(0)
    const [listOpportunityAdmin] = useGetAllOpportunityAdmin()
    const { dataCandidateByID, handleCloseModalCandidate, fetchCandidateOpportunityByID } = props
    const client = useApolloClient()
    const { opportunityID } = useParams()
    const setIsLoading = useSetRecoilState(globalLoadingAtom)


    const handleModalOpen = () => {
        setModalOpen(true)
    }

    const handleCloseModal = () => {
        setModalOpen(false)
    }

    const optionsOpportunity = listOpportunityAdmin.map(function (opportunity) {
        return {
            value: opportunity.id,
            label: opportunity.title
        }
    })

    const onSelectOpportunity = (e) => {
        if (!e) {
            e = {
                value: "",
            };
        }
        setNewOpporunityID(e.value)
    }

    const submitSwicthPosition = async () => {
        if (!newOpportunityID) {
            return alert("New position is required. ")
        }
        try {
            setIsLoading(true)
            const resultSubmit = await UpdateOpportunityCandidate(client, dataCandidateByID.id, parseInt(opportunityID), newOpportunityID)
            if (resultSubmit.data.updateOpportunityCandidate.errMsg === "OK") {
                toastSuccess("Candidate has been transferred")
                fetchCandidateOpportunityByID()
                handleCloseModalCandidate()
                setNewOpporunityID("")
            } else {
                toastError(resultSubmit.data.updateOpportunityCandidate.errMsg)
            }
        } catch (error) {
            toastError("Catch Error Submit", error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <React.Fragment>
            <Button
                color="primary"
                startIcon={<SwitchAccountOutlinedIcon />}
                onClick={handleModalOpen}
            >
                Assign Candidate to Other Position
            </Button>
            <Dialog open={modalOpen} onClose={handleCloseModal}>
                <DialogTitle>
                    Confirmation Assign Candidate to Other Position.
                </DialogTitle>
                <DialogContent>
                    <FormGroup>
                        <Select
                            menuPosition="fixed"
                            options={optionsOpportunity}
                            placeholder="Choose New Opportunity"
                            isClearable
                            onChange={(e) => onSelectOpportunity(e)} />
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModal} color='error'>
                        Close
                    </Button>
                    <Button color='primary' onClick={submitSwicthPosition}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ModalSwicthPosition